// ─── Fase 19 · Referidos / afiliados ─────────────────────────────────────────
// Captura ?ref=CÓDIGO del enlace y lo persiste, para aplicar el cupón del
// afiliado en el checkout. Captura "al leer": la primera lectura (al renderizar
// el landing, que aún trae el ?ref en la URL) lo guarda en localStorage.
const KEY = "pf_ref";

export function getRef() {
  try {
    const fromUrl = (new URLSearchParams(window.location.search).get("ref") || "").trim();
    if (fromUrl) { localStorage.setItem(KEY, fromUrl); return fromUrl; }
    return localStorage.getItem(KEY) || "";
  } catch {
    return "";
  }
}

export function clearRef() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
